import { useQuery } from '@tanstack/react-query';

import type { PublicUser } from '@/types/user.types';
import { userApi } from '@/services/api.service';
import { authStorage } from '@/services/authStorage.service';

export const CURRENT_USER_QUERY_KEY = ['currentUser'] as const;

interface UseCurrentUserResult {
  user: PublicUser | undefined;
  isAuthenticated: boolean;
  isLoading: boolean;
  isError: boolean;
}

export const useCurrentUser = (): UseCurrentUserResult => {
  const hasToken = Boolean(authStorage.getAccessToken());

  const query = useQuery<PublicUser>({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: () => userApi.getMe(),
    enabled: hasToken,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    user: query.data,
    isAuthenticated: hasToken && Boolean(query.data),
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
